import React from 'react'
import { Link } from 'gatsby'
import { Navbar } from 'react-bootstrap'

import * as ROUTES from '../../../constants/routes'
import { AuthUserContext } from '../../Authentication/Session'
import SignOutButton from '../../Authentication/SignOut'
import Navigation from './Navigation'
import SearchInput from '../../SearchInput'

import 'bootstrap/dist/css/bootstrap.min.css'
import HeaderStyles from './header.module.css'

const AuthenticationButtons = ({ authButton }) => (
    <AuthUserContext.Consumer>
        {authUser =>
            authUser ? (
                <div className={HeaderStyles.authButtons}>
                    <Link
                        className={`${authButton} ${HeaderStyles.accountButton}
                `}
                        to={ROUTES.ACCOUNT}
                    >
                        <span>Account</span>
                    </Link>
                    <Link
                        className={`${authButton} ${HeaderStyles.signOutButton}`}
                        to={'/'}
                    >
                        <SignOutButton />
                    </Link>
                </div>
            ) : (
                    <div className={HeaderStyles.authButtons}>
                        <Link
                            className={`${authButton} ${HeaderStyles.signInButton}`}
                            to={ROUTES.SIGN_IN}
                        >
                            Sign in
                    </Link>
                    </div>
                )
        }
    </AuthUserContext.Consumer>
)

export default function Header() {
    // const [isNavCollapsed, setIsNavCollapsed] = useState(true)

    return (
        <Navbar collapseOnSelect expand="lg" className={HeaderStyles.header}>
            <Navbar.Toggle
                aria-controls="responsive-navbar-nav"
                className={HeaderStyles.navToggler}
            >
                <span class="fa fa-bars"></span>
            </Navbar.Toggle>

            <Navbar.Brand className={HeaderStyles.logo}>
                <Link to="/">FeighmiBlog</Link>
            </Navbar.Brand>

            <Navbar.Collapse id="responsive-navbar-nav">
                <Navbar.Toggle
                    className={HeaderStyles.closeButton}
                    aria-controls="responsive-navbar-nav"
                >
                    X
                </Navbar.Toggle>

                <div className={HeaderStyles.ctaContainer}>
                    <AuthenticationButtons
                        authButton={HeaderStyles.authButton}
                    />

                    <SearchInput />
                </div>

                <Navigation />
            </Navbar.Collapse>
        </Navbar>
    )
}
